// Exibe o modal da página institucional
(function () {
  'use strict';

  // Variáveis
  const $linksPags = $('[data-modal-pag]');
  const $modalPagInst = $('#modal-pag-inst');

  // Ao clicar para abrir a página
  $('body').on('click', '[data-modal-pag]', function (ev) {
    ev.preventDefault();
    let pagInst = $(this).data('modal-pag');
    if (!previewMode && pagInst) {
      openInstPag(pagInst);
    }
  });

  // Exibe o modal
  function openInstPag(pag) {
    const urlPag = urlBase + 'core/acoes/checkout/pages.php';
    const data = {
      page: pag,
      store_token: publicToken,
    };
    showLoader();
    $.getJSON(urlPag, data, function (result) {
      //console.log(result);
      hideLoader();
      if (result[0].id) {
        let pagInfos = result[0];
        $modalPagInst.find('.modal-title').html(pagInfos.titulo);
        $modalPagInst.find('.text-formatted').html(pagInfos.texto);
        modalOpen($modalPagInst.attr('id'));
      } else {
        showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
      }
    }).fail(function (qXHR, textStatus, errorThrown) {
      console.log(qXHR);
      hideLoader();
      showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
    });
  }
})();

// Ajusta a posição do WhatsApp inferior caso o contador inferior também esteja habilitado
function handleWhatsLatPos() {
  const $countdownFixed = $('.countdown-wrapper.fixed.bottom');
  const $whatsLateralBottom = $('.contatos-lateral.bottom-right, .contatos-lateral.bottom-left');
  if ($countdownFixed.length > 0 && $whatsLateralBottom.length > 0) {
    if (isMedia('xs') || isMedia('sm')) {
      const countdownHeight = $countdownFixed.outerHeight() + 10;
      $whatsLateralBottom.css('margin-bottom', countdownHeight);
    }
  } else {
    $whatsLateralBottom.css('margin-bottom', 0);
  }
}
handleWhatsLatPos();
